module.exports = __webpack_public_path__ + "img/assets2.6a046b70.svg";